import React, { useState, useContext, useEffect } from "react";
import { Stack, Link, Spinner, SpinnerSize } from "@fluentui/react";
import {
  Drawer,
  Button,
  Space,
  Input,
  Select,
  Switch,
  notification,
} from "antd";
import accountsvg from "./images/accoutrequest.svg";
import Title from "antd/lib/typography/Title";
import { Form } from "antd";
import FormItem from "antd/lib/form/FormItem";
import { Formik } from "formik";
import { observer } from "mobx-react-lite";

import {
  CheckOutlined,
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import { AccountRequestValidationSchema } from "../../../Utility/Validations/HomeValidations";
import HomeStore from "../store/homestore";
import "../style/login.css";
import "../style/accountrequest.css";
const _ = require("underscore");
const { Option } = Select;

export const AccountRequest = observer((props) => {
  const [page, setPage] = useState(1);
  const homeStore = useContext(HomeStore);
  const getInitialdata = async () => {
    if (!homeStore.loadedinitdata) {
      try {
        await homeStore.getInitialData();
      } catch (error) {
        if (!error.response) {
          notification.error({
            key: "error",
            message: "SPARS Feedback",
            description:
              "SPARS Backend Server is not reachable, please contact SPARS support",
          });
        } else {
          notification.error({
            key: "error",
            message: "SPARS Feedback",
            description: error.message,
          });
        }
      }
    }
  };

  useEffect(() => {
    getInitialdata();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [hideCompany, setHideCompany] = useState(true);
  const initFormData = {
    firstname: "",
    lastname: "",
    email: "",
    departmentId: "",
    jobfunction: "",
    usertype: "Staff",
    company: homeStore.brand?.brandName,
    extension: "",
  };
  return (
    <Drawer
      title="New SPARS Account Request"
      placement="right"
      closable={true}
      onClose={() => {
        homeStore.showRequestAccountDialog = false;
      }}
      visible={homeStore.showRequestAccountDialog}
      width="500"
    >
      <Stack
        tokens={{ childrenGap: 10 }}
        className={`${page === 1 ? "show" : "hide"}`}
      >
        <Stack.Item align="center">
          <Title level={5}>Platform Usage Terms and Conditions</Title>
        </Stack.Item>
        <Stack.Item align="center">
          <p>
            <b>SPARS Platform is for the use of authorised users only.</b><br/>
            By clicking on the "I Agree to the usage Terms and Condition" button and requesting for a new account,you agree to abide with OER Acceptable Use of her Software Services speficications.
            Your activities shall comply with OER Policies ,laws and requlations.You shall never share your password with anyone including IT Helpdesk or Support Team 

          </p>
        </Stack.Item>
        <Stack.Item align="center">
          <img src={accountsvg} alt="React Logo" style={{ width: "200px" }} />
        </Stack.Item>
        <Stack.Item align="center" styles={{ root: { paddingTop: "40px" } }}>
          <Link
            onClick={() => {
              setPage(2);
            }}
          >
            I Agree to the usage Terms and Conditions
          </Link>
        </Stack.Item>
      </Stack>

      <Stack
        tokens={{ childrenGap: 3 }}
        className={`${page === 2 ? "show animated jackInTheBox" : "hide"}`}
      >
        <Stack.Item align="center">
          <Formik
            initialValues={initFormData}
            validationSchema={AccountRequestValidationSchema}
            onSubmit={async (values, { setSubmitting, resetForm }) => {
              try {
                homeStore.isloading = true;
                await homeStore.registerUser(values);
                homeStore.isloading = false;
                notification.success({
                  message: "SPARS Feedback",
                  description: "New Account Request submitted successfully",
                });
                homeStore.showRequestAccountDialog = false;
                resetForm({ values: "" });
              } catch (error) {
                const { body, badRequest } = error.response;

                if (badRequest) {
                  notification.error({
                    message: "SPARS Feedback",
                    description: body.errorMsg,
                  });
                } else {
                  notification.error({
                    message: "SPARS Feedback",
                    description: body.errorMsg,
                  });
                }
              } finally {
                homeStore.isloading = false;
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form layout="vertical" onFinish={handleSubmit}>
                <Title level={5}>Your Account Information</Title>
                <Stack>
                  <FormItem
                    label="First Name"
                    required
                    help={touched.firstname && errors.firstname}
                  >
                    <Input
                      prefix={<UserOutlined style={{ color: "#A0AEC0" }} />}
                      value={values?.firstname}
                      name="firstname"
                      onChange={handleChange}
                      allowClear
                    />
                  </FormItem>

                  <FormItem
                    label="Last Name"
                    required
                    help={touched.lastname && errors.lastname}
                  >
                    <Input
                      prefix={<UserOutlined style={{ color: "#A0AEC0" }} />}
                      value={values?.lastname}
                      onChange={handleChange}
                      name="lastname"
                      allowClear
                    />
                  </FormItem>
                  <FormItem
                    label="Email"
                    required
                    help={touched.email && errors.email}
                  >
                    <Input
                      placeholder="Enter a valid work email for verification"
                      prefix={<MailOutlined style={{ color: "#A0AEC0" }} />}
                      value={values?.email}
                      onChange={handleChange}
                      name="email"
                      allowClear
                    />
                  </FormItem>

                  <FormItem
                    label="Job Title"
                    required
                    help={touched.jobfunction && errors.jobfunction}
                  >
                    <Input
                      value={values?.jobfunction}
                      onChange={handleChange}
                      allowClear
                      name="jobfunction"
                    />
                  </FormItem>

                  <FormItem label="Office Extension">
                    <Input
                      placeholder="Enter a valid office extension"
                      prefix={<PhoneOutlined style={{ color: "#A0AEC0" }} />}
                      value={values?.extension}
                      onChange={handleChange}
                      name="extension"
                      allowClear
                    />
                  </FormItem>

                  <FormItem
                    label="Employee Category"
                    required
                    help={touched.usertype && errors.usertype}
                  >
                    <div className="ms-Grid" dir="ltr">
                      <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm7">
                          {" "}
                          Are you a Staff? {"  "}
                        </div>
                        <div className="ms-Grid-col ms-sm5">
                          <Switch
                            checkedChildren="Yes I'm a Staff"
                            unCheckedChildren="No, I'm a Contractor"
                            name="usertype"
                            onChange={(val) => {
                              if (val) {
                                setFieldValue("usertype", "Staff");
                                setFieldValue(
                                  "company",
                                  homeStore.brand?.brandName
                                );
                                setHideCompany(true);
                              } else {
                                setFieldValue("company", "");
                                setFieldValue("usertype", "Contractor");
                                setHideCompany(false);
                              }
                            }}
                            defaultChecked={true}
                          />
                        </div>
                      </div>
                    </div>
                  </FormItem>

                  {!hideCompany && (
                    <FormItem
                      label="Contractor Company"
                      help={touched.company && errors.company}
                    >
                      <Input
                        value={values?.company}
                        onChange={handleChange}
                        allowClear
                        name="company"
                      />
                    </FormItem>
                  )}

                  <FormItem
                    label="Department"
                    required
                    help={touched.departmentId && errors.departmentId}
                  >
                    <Select
                      placeholder="Select your department"
                      name="department"
                      value={values?.departmentId}
                      onChange={(val) => {
                        setFieldValue("departmentId", val, false);
                      }}
                    >
                      {_.sortBy(homeStore.departments, "departmentName").map(
                        (dept) => (
                          <Option
                            value={dept.departmentId}
                            key={dept.departmentId}
                          >
                            <div
                              style={{
                                display: "flex",

                                justifyContent: "space-between",
                              }}
                            >
                              <div>{dept.departmentName}</div>
                              <div className="pill">{dept.code}</div>
                            </div>
                          </Option>
                        )
                      )}
                    </Select>
                  </FormItem>

                  <Stack.Item align="end">
                    <Space size={180}>
                      <Link
                        style={{ marginTop: "20px" }}
                        onClick={() => {
                          setPage(1);
                        }}
                      >
                        Back
                      </Link>
                      <Button
                        type="primary"
                        htmlType="submit"
                        icon={<CheckOutlined />}
                        loading={homeStore.isloading}
                      >
                        Submit
                      </Button>
                    </Space>
                  </Stack.Item>
                  {homeStore.isloading && (
                    <Stack.Item
                      align="center"
                      styles={{
                        root: {
                          paddingTop: "50px",
                        },
                      }}
                    >
                      <Spinner
                        label="submitting your request, please wait..."
                        ariaLive="assertive"
                        labelPosition="right"
                        size={SpinnerSize.large}
                      />
                    </Stack.Item>
                  )}
                </Stack>
              </Form>
            )}
          </Formik>
        </Stack.Item>
      </Stack>
    </Drawer>
  );
});

